"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbstractConfigurationClient = exports.AbstractResourceClient = void 0;
var aws_amplify_1 = require("aws-amplify");
var client_cache_1 = require("./client-cache");
function executeWithValidAuthorizedToken(fn, getNewTokenFn) {
    return __awaiter(this, void 0, void 0, function () {
        var promise;
        var _this = this;
        return __generator(this, function (_a) {
            promise = fn();
            return [2 /*return*/, promise.catch(function (err) { return __awaiter(_this, void 0, void 0, function () {
                    var response, newToken;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                response = err.response;
                                if (!((response && response.status === 401) || err.message === 'Network Error')) return [3 /*break*/, 3];
                                return [4 /*yield*/, getNewTokenFn()];
                            case 1:
                                newToken = _a.sent();
                                client_cache_1.cache.authorizationToken = newToken;
                                return [4 /*yield*/, fn()];
                            case 2: return [2 /*return*/, _a.sent()];
                            case 3: throw err;
                        }
                    });
                }); })];
        });
    });
}
var AbstractResourceClient = /** @class */ (function () {
    function AbstractResourceClient(endpointName, getNewTokenFn) {
        this.endpointName = endpointName;
        this.getNewTokenFn = getNewTokenFn;
    }
    AbstractResourceClient.prototype.getConfig = function () {
        // const expiredToken = 'eyJraWQiOiJDeEMyR21Kb3praGxJWjV2cUR6UmpDWmRyZks2TE9xekQ4Q2l6R2NSUWpnPSIsImFsZyI6IlJTMjU2In0.eyJzdWIiOiI5ZjFjNGM4ZS1hYmY5LTRmMmItOWU2Ni0xYzBkYzNiOTI0MmEiLCJlbWFpbF92ZXJpZmllZCI6dHJ1ZSwiaXNzIjoiaHR0cHM6XC9cL2NvZ25pdG8taWRwLnVzLXdlc3QtMi5hbWF6b25hd3MuY29tXC91cy13ZXN0LTJfcGtqbUhxMlVwIiwiY29nbml0bzp1c2VybmFtZSI6IjlmMWM0YzhlLWFiZjktNGYyYi05ZTY2LTFjMGRjM2I5MjQyYSIsImdpdmVuX25hbWUiOiJBcmp1biIsImN1c3RvbTp0ZW5hbnRJZCI6IjYxMDQiLCJhdWQiOiI2MDgwa2M5ZmlsZzE3YTdqMDB2ZDNzODBpciIsImV2ZW50X2lkIjoiYjA3NWJkMjUtODExYS00MGQxLTgxNGUtN2RjYTE3YmU2ODY4IiwidG9rZW5fdXNlIjoiaWQiLCJhdXRoX3RpbWUiOjE1Njk0NTE3MDQsImV4cCI6MTU2OTQ1NTMwNCwiaWF0IjoxNTY5NDUxNzA0LCJmYW1pbHlfbmFtZSI6ImFzZGFzZCIsImVtYWlsIjoiYXJqdW5rb3BwYWxtYW5qdW5hdGhAZ21haWwuY29tIn0.Sp9dAYHwFpH9Ja-Y8mzfBGWY-gIvjhBx_iS-YB7CJwiHkV6QQaGKggc1bC89vFwHzrzF9RyJeSmd2YWChtezRqAOd3zTszYzuUaQPxbyL4wjxw1Yn_2GCe7wqGkFNoD_b8w9ws-RncCmWiRYAiT6eD8Ii0feYR46stVZPmIrylCa59Xer5nUWo1JXjq1IpDDGFmjvzEImrbvyFQtu62oEAZQJCgK8Of-kYKoRlMj1n-wBg3XFlbRKyRkj7QMK8Rq7Ko_-eIbvMsj1luM4qTi3dL_aWkZFp69OctoXG2ANu4J1p_Xg-ZOuRJfS0eR3Q4eT2dApd3la3CTsa3oK6RwBA';
        var _this = this;
        return executeWithValidAuthorizedToken(function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, aws_amplify_1.API.get(this.endpointName, '/configuration', {
                        headers: {
                            // Authorization: expiredToken,
                            Authorization: client_cache_1.cache.authorizationToken,
                        },
                    })];
            });
        }); }, this.getNewTokenFn);
    };
    AbstractResourceClient.prototype.createConfig = function (payload, versionNumber) {
        var _this = this;
        return executeWithValidAuthorizedToken(function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, aws_amplify_1.API.post(this.endpointName, '/configuration', {
                        configData: payload,
                        body: {
                            customerId: client_cache_1.cache.customerId,
                            versionNumber: versionNumber,
                        },
                        headers: {
                            Authorization: client_cache_1.cache.authorizationToken,
                        },
                    })];
            });
        }); }, this.getNewTokenFn);
    };
    return AbstractResourceClient;
}());
exports.AbstractResourceClient = AbstractResourceClient;
var AbstractConfigurationClient = /** @class */ (function (_super) {
    __extends(AbstractConfigurationClient, _super);
    function AbstractConfigurationClient(endpointName, getNewTokenFn) {
        return _super.call(this, endpointName, getNewTokenFn) || this;
    }
    AbstractConfigurationClient.prototype.get = function () {
        return _super.prototype.getConfig.call(this).then(function (result) { return result.Item; });
    };
    AbstractConfigurationClient.prototype.create = function (payload, versionNumber) {
        return _super.prototype.createConfig.call(this, payload, versionNumber);
    };
    return AbstractConfigurationClient;
}(AbstractResourceClient));
exports.AbstractConfigurationClient = AbstractConfigurationClient;
// update(payload: object) {
//   return super.one(payload).then(result => {
//     if (!result) {
//       return null;
//     }
//
//     return result;
//   });
// }
// remove(id: string): Promise<void> {
//   const payload = {
//     requestContext: {
//       customerId: id
//     }
//   };
//
//   return super.one(payload);
// }
//# sourceMappingURL=abstract-resource-client.js.map